import Navbar from "./Navbar";
import { Box, Theme, useMediaQuery } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import AppHeader from "./AppHeader";
import { COLORS } from "../../theme/theme-options";

const Desktop: React.FC = () => {
    return (
        <Box
            sx={{
                display: "flex",
                minHeight: "100%",
                margin: "0 auto",
                flexDirection: "row",
                backgroundColor: "#060d1a",
                backgroundBlendMode: "overlay",
            }}
        >
            <Navbar />
            <Box sx={{ width: "100%", minWidth: 0 }}>
                <AppHeader />
                <Box
                    component="main"
                    sx={{
                        color: COLORS.grey[100],
                        minHeight: "calc(100vh - 64px)",
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
};

const Mobile: React.FC = () => {
    const location = useLocation();
    const isDashboardDetail = location.pathname.startsWith("/dashboards/");
    return (
        <Box
            sx={{
                display: "flex",
                minHeight: "100%",
                flexDirection: "row",
                backgroundColor: "#060d1a",
                backgroundBlendMode: "overlay",
            }}
        >
            <Navbar />
            <Box sx={{ width: "100%", minWidth: 0 }}>
                <AppHeader />
                <Box component="main" sx={{ p: isDashboardDetail ? 0 : 2, color: COLORS.grey[100] }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
};

const Layout: React.FC = () => {
    const isSmallScreen = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down("sm"),
    );
    return isSmallScreen ? <Mobile /> : <Desktop />;
};

export default Layout;
